/**
 * Guards DocSearch's global keyboard handler against malformed keydown events.
 *
 * @docsearch/react registers a window keydown listener that reads
 * `event.key.toLowerCase()` to detect its Cmd+K shortcut. Some password
 * managers and autofill extensions dispatch synthetic keydown events with no
 * `key`, which makes that read throw
 * "Cannot read properties of undefined (reading 'toLowerCase')" while a user
 * types in form fields.
 *
 * This capture-phase listener runs before DocSearch's bubble-phase window
 * listener and drops only those malformed events (a real KeyboardEvent always
 * has a string `key`). It does not call preventDefault, so normal typing is
 * unaffected.
 */
if (typeof window !== 'undefined') {
  window.addEventListener(
    'keydown',
    (event) => {
      if (typeof event.key !== 'string') {
        event.stopImmediatePropagation();
      }
    },
    true,
  );
}
